// extracted by mini-css-extract-plugin
module.exports = {"termlist":"TermsConditionOffline_termlist__1oTiM","checkagreement":"TermsConditionOffline_checkagreement__1liVF"};